// src/components/layout/TransitionOverlay.jsx
import React from "react";
import CenteredLogo from "./CenteredLogo";

export default function TransitionOverlay({ stage }) {
  return (
    <div
      className={`overlay 
        ${stage === "in" ? "show" : ""} 
        ${stage === "out" ? "hide" : ""}`}
      aria-hidden="true"
    >
      <CenteredLogo label="Alkeme UX" size={110} />
    </div>
  );
}